<template>
  <div class="col-12 page_content_area">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="page_title">
            各系實習機會
          </div>
          <off-campus-internship-block
            v-for="college in internshipsGetter"
            :key="college.college_id"
            :college="college"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import OffCampusInternshipBlock from '~components/pages/off-campus-internship/OffCampusInternshipBlock'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'OffCampusInternshipContent',
  components: {
    OffCampusInternshipBlock
  },
  computed: {
    ...mapGetters('pages/intern', [
      'internshipsGetter'
    ])
  },
  async created () {
    await this.getInternships()
  },
  methods: {
    ...mapActions('pages/intern', [
      'getInternships'
    ])
  }
}
</script>
